<template>
  <div id="app">
    <Hero1 :content="content.banner"/>
    <Section1 :content="content.section1" />
    <Schedule id="schedule" :content="content.schedule"/>
    <Location id="location" :content="content.location" />
    <FAQ id="faq" :content="content.faq"/>
    <Footer/>
  </div>
</template>

<script>
  import Hero1 from './components/Hero1.vue'
  import Section1 from './components/Section1.vue'
  import Schedule from './components/ScheduleAsync.vue'
  import Location from './components/Location.vue'
  import FAQ from './components/FAQs.vue'
  import Footer from './components/Footer.vue'

  export default {
    name: 'app',
    created() {
      this.$ga.page('/')
    },
    components: {
      Schedule,
      Hero1,
      Location,
      FAQ,
      Section1,
      Footer
    },
    data() {
      return {
        content: require('./assets/content.us-en.json')
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }


</style>